import useFormatDateTime from "../useFormatDateTime/useFormatDateTime";
import useFormatRelativeTime from "../useFormatRelativeTime/useFormatRelativeTime";
import { FORMAT_INTL_OPTIONS_MAP } from "./useFormatDate";
import { AnyDate } from "./useFormatDate.types";

export function useFormatCompactDate(): (date: AnyDate) => string {
    const formatRelativeTime = useFormatRelativeTime();
    const formatDateTime = useFormatDateTime();

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    function formatCompactDate(date: AnyDate): string {
        const parsedDate = new Date(date);
        let leftTime = "";
        if (parsedDate >= today) {
            leftTime = formatRelativeTime(0, { relativetime: "day", numeric: "auto" }).capitalize();
        } else if (parsedDate >= yesterday) {
            leftTime = formatRelativeTime(-1, { relativetime: "day", numeric: "auto" }).capitalize();
        } else {
            leftTime = formatDateTime(parsedDate, FORMAT_INTL_OPTIONS_MAP["slashed"]);
        }
        const time = formatDateTime(parsedDate, FORMAT_INTL_OPTIONS_MAP["compact"]).toUpperCase();
        return `${leftTime}, ${time}`;
    }

    return formatCompactDate;
}
